<template>
    <v-col cols="12" class="pr-6">
        <v-row>
            <v-col cols="12" align="start" class="ml-4 mt-4 color-text text-h5">
                {{ $t('profile.achievements') }}
            </v-col>
            <v-col cols="12" align="center">
                <v-card
                    elevation="12"
                    :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?200:(this.$vuetify.breakpoint.xl?300:250)"
                >
                    <v-row align="center" justify="space-between" class="">
                        <v-btn icon small @click="previous" v-show="btnSize==='30'">
                            <v-img src="/img/user/back-arrow.svg" :height="btnSize" :width="btnSize"></v-img>
                        </v-btn>
                        <v-btn icon x-large @click="previous" v-show="btnSize==='53'">
                            <v-img src="/img/user/back-arrow.svg" :height="btnSize" :width="btnSize"></v-img>
                        </v-btn>
                        <v-col cols="9" md="10" xl="11">
                            <v-carousel
                                :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm?190:(this.$vuetify.breakpoint.xl?270:220)"
                                hide-delimiter-background
                                light
                                :show-arrows="false"
                                v-model="index"
                            >
                                <v-carousel-item
                                    v-for="(slide, i) in matrix"
                                    :key="i"
                                >
                                    <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="space-around"
                                    >
                                        <v-col
                                            cols="4"
                                            sm="3"
                                            md="2"
                                            class="px-sm-2"
                                            v-for="(medal, i) in slide"
                                            :key="i"
                                        >
                                            <v-card
                                                elevation="0"
                                                >
                                                <v-img
                                                    :src="
                                                        `${$utils.globalConstants.BASE_ASSETS_URL}/achievements/${medal.achievement.resource.resourceUrl}`
                                                    "
                                                    max-height="200"
                                                    :width="iconWidth"
                                                    v-if="medal.accomplished"
                                                />
                                                <v-img
                                                    src="/img/user/achievement-locked.png"
                                                    max-height="200"
                                                    :width="iconWidth"
                                                    v-else
                                                />
                                            </v-card>
                                            <p class="text-desc">
                                                {{ medal.accomplished ? medal.achievement.prize : $t('store.achievement_locked') }}
                                            </p>
                                        </v-col>
                                    </v-row>
                                </v-carousel-item>
                            </v-carousel>
                        </v-col>
                        <v-btn icon small @click="next" v-show="btnSize==='30'">
                            <v-img src="/img/user/next-arrow.svg" :height="btnSize" :width="btnSize"></v-img>
                        </v-btn>
                        <v-btn icon x-large @click="next" v-show="btnSize==='53'">
                            <v-img src="/img/user/next-arrow.svg" :height="btnSize" :width="btnSize"></v-img>
                        </v-btn>
                    </v-row>
                    <v-overlay absolute :value="achievementsByUser.length<1" opacity="0">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            size="150"
                            :width="15"
                        />
                    </v-overlay>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>

import { mapState } from 'vuex'
import AchievementService from '../../services/achievement'
import global from '@/constants/GlobalConstant'

export default {
    data() {
        return {
            achievementsByUser: [],
            index: 0,
            slides: [],
        }
    },
    computed: {
        ...mapState({
            userId: (state) => state.userData.user.id
        }),
        iconWidth() {
            if (this.$vuetify.breakpoint.sm) {
                return '40%'
            }
            return '50%'
        },
        btnSize() {
            if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
                return '30'
            }
            return '53'
        },
        matrix() {
            if (!this.achievementsByUser) {
                return this.listToMatrix([], 1)
            }
            if (this.$vuetify.breakpoint.xs) {
                return this.listToMatrix(this.achievementsByUser, 3)
            }
            if (this.$vuetify.breakpoint.sm) {
                return this.listToMatrix(this.achievementsByUser, 4)
            }
            return this.listToMatrix(this.achievementsByUser, 6)
        }
    },
    created() {
        this.getAchievementsByUser()
    },
    methods: {
        getAchievementsByUser() {
            AchievementService.getAchievementsByUser(this.userId)
                .then((response) => {
                    this.achievementsByUser = response.content
                })
                .catch((error) => console.error(error))
        },
        listToMatrix(list, elementsPerSubArray) {
            const matrix = []
            let i
            let k

            for (i = 0, k = -1; i < list.length; i+=1) {
                if (i % elementsPerSubArray === 0) {
                    k+=1;
                    matrix[k] = [];
                }
                matrix[k].push(list[i]);
            }
            this.slides = matrix.length
            return matrix;
        },
        next() {
            this.index += this.index < (this.slides - 1) ? 1 : 0
        },
        previous() {
            this.index -= this.index > 0 ? 1 : 0
        }
    }
}
</script>
<style scoped>
.color-text {
    color: #4A3216;
}
.v-card {
    border-radius: 20px;
}
.text-desc {
    font-size: 1.75rem;
}
@media (max-width: 649px) {
    .text-desc {
        font-size: .55rem;
    }
}
@media (min-width: 650px) {
    .text-desc {
        font-size: .7rem;
    }
}
@media (min-width: 850px) {
    .text-desc {
        font-size: .8rem;
    }
}
@media (min-width: 900px) {
    .text-desc {
        font-size: .85rem;
    }
}
@media (min-width: 1264px) {
    .text-desc {
        font-size: 1.0rem;
    }
}
@media (min-width: 1450px) {
    .text-desc {
        font-size: 1.1rem;
    }
}
@media (min-width: 1904px) {
    .text-desc {
        font-size: 1.4rem;
    }
}
</style>